import React, { useState } from 'react';
import { inquiryData } from '../data/mock';
import { toast } from 'sonner';

const Inquiry = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    brandName: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    toast.success('Thank you. We will be in touch shortly.');
    setFormData({
      name: '',
      email: '',
      brandName: '',
      message: ''
    });
  };

  return (
    <section id="contact" className="inquiry-section">
      <div className="container">
        <div className="inquiry-content-centered">
          <div className="inquiry-location">{inquiryData.location}</div>
          <h2 className="inquiry-tagline">{inquiryData.tagline}</h2>
          
          <form onSubmit={handleSubmit} className="inquiry-form">
            <div className="form-field">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
                className="editorial-input"
              />
            </div>

            <div className="form-field">
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                required
                className="editorial-input"
              />
            </div>

            <div className="form-field">
              <input
                type="text"
                name="brandName"
                placeholder="Brand Name"
                value={formData.brandName}
                onChange={handleChange}
                required
                className="editorial-input"
              />
            </div>

            <div className="form-field">
              <textarea
                name="message"
                placeholder="Tell us about your brand and goals (Optional)"
                value={formData.message}
                onChange={handleChange}
                rows="5"
                className="editorial-textarea"
              />
            </div>

            <button type="submit" className="editorial-submit-btn">
              [Collaborations →]
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Inquiry;
